import React from 'react';
import { creativeVideoMimeTypeFromUrl } from '../../../../utils/creativeAspectRatio';
import './CreativeEditorModal.css';

export default function CreativePreviewModal({ slot, previewUrl, isVideo, videoMimeType, onCancel, onNext }) {
    const frameClass = slot === 'horizontal' ? 'landscape' : 'portrait';
    const resolvedVideoType = videoMimeType || creativeVideoMimeTypeFromUrl(previewUrl);

    return (
        <>
            <div className="creativeEditorModal creativePreviewModal" role="dialog" aria-modal="true" aria-labelledby="creative-preview-title">
                <h2 id="creative-preview-title" className="creativeEditorTitle creativePreviewTitle">
                    What your ad will look like
                </h2>

                <div className={`creativePreviewFrame ${frameClass}`}>
                    {isVideo ? (
                        <video className="creativePreviewMedia" controls muted playsInline preload="metadata">
                            <source src={previewUrl} type={resolvedVideoType} />
                        </video>
                    ) : (
                        <img src={previewUrl} alt="Ad preview" className="creativePreviewMedia" />
                    )}
                </div>

                <div className="creativePreviewActions">
                    <button type="button" className="creativePreviewCancelBtn" onClick={onCancel}>
                        Cancel
                    </button>
                    <button type="button" className="creativeEditorPrimaryBtn creativePreviewNextBtn" onClick={onNext}>
                        Next
                    </button>
                </div>
            </div>
            <div className="campaignModalBackdrop" />
        </>
    );
}
